

















import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import 'floating-vue/dist/style.css';
import { Tooltip } from 'floating-vue';

// 这个hide函数就是 floating-vue 的函数,只是为了修复一些问题所以重写了这个函数
Tooltip.components.Popper.methods.hide = function hide({ event = null, skipDelay = false, skipAiming = false } = {}) {
    if (this.$_hideInProgress) return;

    // Abort if child is shown
    if (this.shownChildren.size > 0) {
        this.$_pendingHide = true;
        return;
    }

    /**
     * 修复部分 - start
     * 修复说明
     * 1. 这里的判断和setTimeout是为了处理 tooltip 嵌套 tooltip 的场景,我们目前没有这样的场景,注释掉节省部分判断时间
     * 2. 修复前会在判断中都return打断组件隐藏过程,实际上只需要在有 this.parentPopper 的时候才需要return
     *    其余场景return的话会导致tooltip显示多个无法自动关闭问题.
     */
    // // Abort if aiming for the popper
    // if (!skipAiming && this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
    //     if (this.parentPopper) {
    //         console.log(this.parentPopper, 'this.parentPopper');
    //         this.parentPopper.lockedChild = this;
    //         clearTimeout(this.parentPopper.lockedChildTimer);
    //         this.parentPopper.lockedChildTimer = setTimeout(() => {
    //             if (this.parentPopper.lockedChild === this) {
    //                 this.parentPopper.lockedChild.hide({ skipDelay });
    //                 this.parentPopper.lockedChild = null;
    //             }
    //         }, 1000);
    //         // 修复重点,改为在这里return
    //         return;
    //     }

    //     // 修复重点,这里不能return
    //     // return;
    // }
    /** 修复部分 - end */

    if (this.parentPopper?.lockedChild === this) {
        this.parentPopper.lockedChild = null;
    }

    this.$_pendingHide = false;
    this.$_scheduleHide(event, skipDelay);
    this.$emit('hide');
    this.$emit('update:shown', false);
};

export default defineComponent({
    // 因为用到了 attrs 透传给 VTooltip 组件
    inheritAttrs: false,
    components: {
        VTooltip: Tooltip,
    },
    props: {
        content: {
            type: String,
            default: '',
        },
        maxWidth: {
            type: [Number, String],
            default: '',
        },

        offset: {
            type: Number,
        },

        transferClassName: {
            type: String,
            default: '',
        },
        theme: {
            type: String as PropType<'dark' | 'light'>,
            default: 'dark',
        },

        // 这里专门接收placement是因为在部分组件，如果用 h('Tooltip') 渲染的话，placement会无法透传
        placement: {
            type: String as PropType<
                | 'top'
                | 'top-start'
                | 'top-end'
                | 'bottom'
                | 'bottom-start'
                | 'bottom-end'
                | 'left'
                | 'left-start'
                | 'left-end'
                | 'right'
                | 'right-start'
                | 'right-end'
            >,
            default: 'top',
        },
    },
    setup(props, ctx) {
        const innerStyles = computed(() => {
            const styles: Record<string, string> = {};
            if (props.maxWidth) styles['max-width'] = `${props.maxWidth}px`;
            return styles;
        });

        const firstTimeShow = ref(false);

        // 兼容性的 props
        const compatibleProps = computed(() => {
            const _compatibleProps: Record<string, unknown> = {
                strategy: 'fixed', // 用fixed定位，用absolute会页面宽高出现空白问题
                distance: 0, // 新控件贴的太近了，给一些默认距离
                popperTriggers: ['hover'], // 保持Popper能鼠标移上去复制
                // autoHide: true,
                delay: { show: 0, hide: 100 },
                // hideTriggers: (triggers: string[]) => [...triggers, 'click'],
                ...(ctx.attrs || {}),
            };

            if (props.offset) {
                _compatibleProps.distance = props.offset;
            }

            // 兼容之前透传 class
            if (props.transferClassName) {
                _compatibleProps.popperClass = props.transferClassName;
            }

            // 兼容样式
            if (props.theme === 'light') {
                _compatibleProps.popperClass = `v-popper-light ${_compatibleProps.popperClass || ''}`;
            }

            // 为了更好的hover，底部加了10px，不过第一次tooltip显示的时候没计算进去，手动补一下距离
            if (!firstTimeShow.value) {
                _compatibleProps.distance = ((_compatibleProps.distance || 0) as number) + 10;
            }

            return _compatibleProps;
        });

        const onShow = () => {
            firstTimeShow.value = true;
            ctx.emit('show');
        };

        return { innerStyles, compatibleProps, onShow };
    },
});
